import React, { useState } from 'react';
import Img from 'gatsby-image';
import Container from '../Container';
import WidgetCard from '../WidgetCard';
import useMatchMedia from '../../hooks/match-media';
import WidgetSocial from '../WidgetSocial';

const ParagraphNews = ({
  content, dropcap, numCols, widgetCard, author, date, caption, coverImage
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const mediaToMatch = '(min-width: 1366px)';
  useMatchMedia(setIsDesktop, mediaToMatch);
  const htmlParagraphContent = { __html: content };

  const paragraphClasses = `paragraph-content paragraph-news-content
    ${dropcap ? 'paragraph--with-dropcap' : ''}`.replace(/\n\s+/g, ' ');

  return (
    <Container className={paragraphClasses}>
      <div className="paragraph-content__wrapper">
        <div className="paragraph__widget-social-desktop">
          <WidgetSocial
            author={author}
            date={date}
          />
        </div>
        <div className={`paragraph__container num-cols--${numCols}`}>
          {
            coverImage && (
              <div className="paragraph-news__cover">
                <figure className="paragraph-news__image-figure">
                  {coverImage && (
                    <div className="paragraph-news__image-container">
                      <Img
                        fluid={{
                          ...coverImage.fluid
                        }}
                        alt={coverImage.alt}
                        objectFit="contain"
                        className={`paragraph-news__image ${(coverImage.height > coverImage.width) ? 'paragraph-news__image--vertical' : ''}`}
                      />
                    </div>
                  )}
                  { caption && (
                    <figcaption className="paragraph-news__image-caption caption">
                      <ul>
                        <li>{caption}</li>
                      </ul>
                    </figcaption>
                  )}
                </figure>
              </div>
            )
          }
          {content && <div className="paragraph__wrapper" dangerouslySetInnerHTML={htmlParagraphContent} />}
        </div>
        {
          widgetCard
          && isDesktop
          && (
            <div className="paragraph_widget-card">
              <WidgetCard
                widgetCard={widgetCard}
              />
            </div>
          )
        }
      </div>
    </Container>
  );
};

export default ParagraphNews;
